import {createStore} from 'vuex';
import { authToken, setResearchIdentity } from '@/modules/cohort/researchPermissions.js'
import {createAxiosInstance} from './axios'; // 确保路径正确
let userRequest = 0

export function loadLocalStorage(d) {
    let res = localStorage.getItem(d) || '{}';
    return JSON.parse(res);
}

export function saveLocalStorage(d, data) {
    localStorage.setItem(d, JSON.stringify(data));
}

export const store = createStore({
    state: {
        user: "", // 用户信息
        userToken: "",
        isUpdating: false, // 新增：控制批量更新的加载状态
        filter: "",//首页跳转筛选条件
        endpoint: "",
        systemState: {}, // 系统状态信息
        net_error: "",
        net_err_time: 0,
        jumpData: {}
    },
    mutations: {
        setEndpoint(state, endpoint) {
            state.endpoint = endpoint;
            console.log(endpoint);
        },
        clearEndpoint(state) {
            state.endpoint = null;
            console.log('logout');
        },
        setUser(state, user) {
            state.user = user;
            state.userToken = authToken();
            setResearchIdentity(user, state.userToken);
        },
        clearUser(state) {
            state.user = null;
            state.userToken = '';
            userRequest++;
            localStorage.removeItem('authToken1_org');
            localStorage.removeItem('authToken_org');
            setResearchIdentity(null, '');
            localStorage.removeItem('userOrg');
        },
        setSystemState(state, systemState) {
            state.systemState = systemState;
        },
        setNetError(state, net_error) {
            state.net_error = net_error;
            state.net_err_time = new Date().getTime();
        },


        // 新增mutations来更新isUpdating状态
        startUpdating(state) {
            state.isUpdating = true;
        },
        stopUpdating(state) {
            state.isUpdating = false;
        },
        setFilter(state, filter) {
            state.filter = filter;
        },
        setJumpData(state, data) {
            state.jumpData = data;

        }
    },
    actions: {
        async fetchUser({commit, state}) {
            const token = authToken(), request = ++userRequest;
            if (!token) { commit('clearUser'); return null }
            if (state.userToken !== token) {
                state.user = null; state.userToken = '';
                setResearchIdentity(null, token, true);
            }
            try {
                const axiosInstance = createAxiosInstance("数据服务器");
                const response = await axiosInstance.get("/currentuser/"); // 使用新的 axios 实例请求数据
                if (response && response.status === 200 && response.data) {
                    if (request !== userRequest || token !== authToken()) return null;
                    const userData = response.data.data;
                    if (!userData || typeof userData !== 'object') throw new Error('Invalid current user');
                    commit('setUser', userData);
                    // 保存 org 到 localStorage，用于路由判断
                    if (userData && userData.org) {
                        const oldUserOrg = localStorage.getItem('userOrg');
                        localStorage.setItem('userOrg', userData.org);
                        console.log(`[fetchUser] 保存用户 org 到 localStorage: ${userData.org} (旧值: ${oldUserOrg || '无'})`);
                        console.log(`[fetchUser] 用户信息:`, {
                            username: userData.username || userData.user,
                            role: userData.role,
                            org: userData.org
                        });
                    } else {
                        console.warn('[fetchUser] 用户数据中没有org字段:', userData);
                    }
                    if (response.sys_info) {
                        commit('setSystemState', response.sys_info);
                    }
                    return userData;
                }
                throw new Error('Invalid current user response');
            } catch (error) {
                if (request !== userRequest || token !== authToken()) return null;
                setResearchIdentity(null, token, true);
                state.user = null; state.userToken = '';
                if (error.response && error.response.status === 401) {
                    console.log('[fetchUser] 检测到401错误，登录已过期');
                    // store.dispatch('logout');
                    commit('clearUser');
                    localStorage.removeItem('userOrg');
                    // 不在这里重定向，让axios拦截器处理
                } else {
                    // 只记录非401错误
                    console.error('[fetchUser] Error fetching user:', error.message || error);
                }
                return null;
            }
        },
        async logout({commit}) {
            try {
                let axiosInstance = createAxiosInstance("数据服务器");
                axiosInstance.post('/logout/'); // 发送登出请求到后端
                commit('clearUser'); // 清除本地用户信息
                // 重定向到登录页面或进行其他操作
            } catch (error) {
                console.error('Error during logout:', error);
            }
        },
        // 可以在此处添加更多actions
    },
});
